<template>
  <div class="follow_upload">

    <mu-tabs :value.sync="active"
             @change="tabChange"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>上传资料</mu-tab>
      <mu-tab>上传历史</mu-tab>
    </mu-tabs>

    <template v-if="active == 0">
      <div class="data">

        <div class="choice">
          <van-field
              readonly
              clickable
              label="选择就诊人"
              name="relationship"
              :value="( form.patientId ? See.filter((item) => { return item.id == form.patientId })[0].patientName : null )"
              placeholder="请选择就诊人"
              @click="clickSee()"
              :rules="[{ required: true, message: '请选择就诊人' }]"
          >
            <template #right-icon>
              <div class="icon">
                <i class="iconfont icon-jiaren"></i>
                <p>选择</p>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPickerRela" position="bottom">
            <van-picker
                show-toolbar
                value-key="patientName"
                :columns="See"
                @confirm="onConfirmSee"
                @cancel="showPickerRela = false"
            />
          </van-popup>
        </div>


        <div class="data_form">
          <van-form @submit="onSubmit(form)" :show-error="false" >
            <div class="form_input">
<!--              <div class="title">-->
<!--                <p>选择就诊人</p>-->
<!--              </div>-->
<!--              <van-field-->
<!--                  readonly-->
<!--                  clickable-->
<!--                  name="relationship"-->
<!--                  :value="( form.patientId ? See.filter((item) => { return item.id == form.patientId })[0].patientName : null )"-->
<!--                  placeholder="请选择就诊人"-->
<!--                  @click="showPickerRela = true"-->
<!--                  :rules="[{ required: true, message: '请选择就诊人' }]"-->
<!--              >-->
<!--                <template #right-icon>-->
<!--                  <i class="iconfont icon-tiaozhuan" style="color: #3390F3; "></i>-->
<!--                </template>-->
<!--              </van-field>-->
<!--              <van-popup v-model="showPickerRela" position="bottom">-->
<!--                <van-picker-->
<!--                    show-toolbar-->
<!--                    value-key="patientName"-->
<!--                    :columns="See"-->
<!--                    @confirm="onConfirmSee"-->
<!--                    @cancel="showPickerRela = false"-->
<!--                />-->
<!--              </van-popup>-->
              <div class="title">
                <p>表现现象</p>
                <p>{{ form.shows.length }}/50</p>
              </div>
              <van-field
                  v-model="form.shows"
                  maxlength="50"
                  name="shows"
                  placeholder="请填写表现现象"
                  :rules="[{ required: true, message: '请填写表现现象' }]"
              />
              <div class="title">
                <p>具体描述</p>
                <p>{{ form.description.length }}/200</p>
              </div>
              <van-field
                  v-model="form.description"
                  maxlength="200"
                  type="textarea"
                  name="description"
                  placeholder="请填写具体描述"
                  :rules="[{ required: true, message: '请填写具体描述' }]"
              />
            </div>
            <!-- 上传 -->
            <div class="uploads">
              <div class="van_up">
                <van-uploader v-model="fileList"
                              :deletable="true"
                              :multiple="true"
                              :before-delete ="delete_upload"
                              :max-size="10 * 1024 * 1024"
                              @oversize="onOversize"
                              :max-count="9"
                              :after-read="afterJust" >
                  <template #default>
                    <div class="uploader"></div>
                  </template>
                </van-uploader>
              </div>
              <!-- 功能介绍 -->
              <p class="introduce">
                <span>功能介绍：</span>
                为了更好的获得咨询帮助，请详细描述您的身体状况和诊疗经历，提出您想解决的疑问，如果有相关图片也请一并上传（包括血生化检查报告、CT等影像检查报告、心电图等功能检查报告、体检报告、病历、处方等内容）我们将安排对应的医生为您提供分析和咨询。御锦会确保您的隐私安全。
              </p>
            </div>
            <div class="button">
              <van-button round block type="info" :disabled="load_button" :loading="load_button" native-type="submit" >提交</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </template>


    <template v-if="active == 1">
      <template v-if="list.length != 0">
        <ul class="history">
          <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
            <li v-for="item in list" :key="item.id" @click="history_deta(item.id)">
              <div class="title">
                <p v-if="item.diagnosed == 0" >已上传</p>
                <p v-if="item.diagnosed == 1"  class="finish">已完成</p>
                <p>{{ item.createTime }}</p>
              </div>
              <p class="content">
                就诊人：{{ item.name }}
              </p>
              <div class="del">
                <p @click.stop="del(item)" >删除</p>
              </div>
            </li>
          </mu-load-more>
        </ul>
      </template>

      <template v-else>
        <NoList>
          <template #text>
            <p>暂无数据</p>
          </template>
        </NoList>
      </template>
    </template>


  </div>
</template>

<script>
export default {
  name: "FollowUpload",
  data() {
    return{
      active: 0,
      fileList: [],
      form: {
        shows: "",
        description: "",
        patientId: null,
        fileList: []
      },
      json_list: {
        pageNum: 1,
        pageSize: 10,
      },
      loadall: false,
      loading: false,
      list: [],
      showPickerRela: false,
      See: [],
      load_button: false,
    }
  },
  created() {
    this.get_list(this.json_list);
    this.grt_see_list();
  },
  mounted() {

  },
  methods: {
    clickSee() {
      if(this.See.length != 0) {
        this.showPickerRela = true;
      }else {
        this.$dialog.confirm({
          message: '暂无就诊人,是否去添加就诊人',
        })
            .then(() => {
              // on confirm

              this.$router.push({
                path: "/InfoList"
              })

            })
            .catch(() => {
              // on cancel
            });
      }
    },
    onConfirmSee(e) {
      console.log(e);

      this.form.patientId= e.id;
      this.showPickerRela= false;

    },
    // 获取就诊人选择器
    grt_see_list() {
      this.$get("patient/page")
          .then(res => {
            if(res) {
              console.log(res)
              this.See= res.data;
            }
          })
    },
    load() {
      this.loading= true;
      this.json_list.pageNum= this.json_list.pageNum + 1;
      this.get_list(this.json_list);
    },
    get_list(y) {
      this.$get("report/upload/record",y)
        .then(res => {
          if(res) {
            this.loadall= !res.data.hasNextPage;
            this.loading= false;

            res.data.list.forEach((item)=> {
              this.list.push(item);
            })

            console.log(res);
          }
        })
    },
    del(e) {
      console.log(e)

      this.$dialog.confirm({
        message: '是否要删除该条上传记录',
      })
          .then(() => {
            // on confirm

            this.$del("report/del",e.id,true)
              .then(res => {
                if(res) {
                  console.log(res);
                  this.list= [];
                  this.json_list.pageNum= 1;
                  this.get_list(this.json_list);
                }
              })

          })
          .catch(() => {
            // on cancel
          });

    },
    tabChange(e) {
      if(e == 0) {
        console.log(e)
      }else {
        this.list= [];
        this.json_list.pageNum= 1;
        this.get_list(this.json_list);
      }
    },
    // 上传图片
    afterJust(file) {
      file.status = 'uploading';
      file.message = '上传中...';

      console.log(file.file)

      file.status = 'done';


    },
    delete_upload(file,detail) {
      this.fileList.splice(detail.index,1)
    },
    history_deta(e) {
      this.$router.push({
        path: "/HistoryDeta",
        query: {
          id: e
        }
      })
    },
    onOversize() {
      this.$toast.error("最大可上传10M");
    },
    onSubmit(formName) {
      this.load_button= true;
      var formData = new FormData();

      this.fileList.forEach((item) => {
        formData.append('fileList', item.file);
      })

      formData.append('shows', formName.shows);
      formData.append('description', formName.description);
      formData.append('patientId', formName.patientId);
      console.log(formData);

      this.$post("report/upload",formData)
        .then(res => {
          if(res) {
            console.log(res);
            this.list= [];
            this.json_list.pageNum= 1;
            this.get_list(this.json_list);

            this.active = 1;
            this.fileList= [];
            this.form.shows= "";
            this.form.description= "";
            this.form.patientId= "";
          }
          this.load_button= false;
        })
        .catch(() => {
          this.load_button= false;
        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Follow/FollowUpload";
</style>
